import { estiloDaEtiqueta } from './contraste';

/**
 * A etiqueta como a equipe a vê: a cor da clínica tingindo o fundo.
 *
 * O texto passa por `estiloDaEtiqueta` porque a cor é cadastro do cliente — a
 * cor cheia sobre o próprio tingido dá 2:1 no verde, e lista de cores
 * aprovadas não resolve quando a clínica escolhe a sua.
 */
export function EtiquetaChip({ nome, cor }: { nome: string; cor: string }) {
    const estilo = estiloDaEtiqueta(cor);
    return (
        <span
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, height: 22, padding: '0 9px',
                borderRadius: 'var(--radius-pill)', background: estilo.background, color: estilo.color,
                fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
            }}
        >
            <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: '50%', background: cor, flex: '0 0 auto' }} />
            {nome}
        </span>
    );
}
